/* eslint-disable jsx-a11y/anchor-is-valid */

import Widget from "components/widget/Widget";
import SearchField from "components/fields/SearchField";
import { IoIosCopy } from "react-icons/io";
import { PiQuestionLight } from "react-icons/pi";
import { PiEyeLight } from "react-icons/pi";
import { MdNavigateNext, MdNavigateBefore, MdSkipPrevious, MdSkipNext } from "react-icons/md";
import { FaAngleDown } from "react-icons/fa";
import { HiOutlineLightBulb } from "react-icons/hi";
import { Link } from "react-router-dom";
import NftIcon from "assets/img/icons/nft.png";
import Opensea from "assets/img/icons/opensea.png";
import VerifiedIcon from "assets/img/icons/verified.png";

const NftDetail = () => {
  return (
    <div className="relative">
      {/* Card widget */}
      <div className="header-back-gradient">
      <div className="container py-6">
          <div className="w-full px-2.5 md:px-3 lg:px-5">
            <div className="w-full flex items-center ">
              <div className="md:flex justify-between w-full md:py-6 md:gap-6">
                <div className="md:mb-0 mb-4">
                  <p className="relative text-header text-white mb-3 flex items-center gap-2">
                    Owl Bridge
                    <img
                      width={29}
                      height={29}
                      src={VerifiedIcon}
                      alt=""
                    />
                  </p>
                  <div className="flex gap-[2px] items-center">
                    <div className="truncateWrapper">
                      <span className="text-large truncate mr-1 text-white">
                      BrW3yUL4E3WDtK8Dyy5zvVs1KifxfVjKztvEDNxQhz7b
                      </span>
                    </div>
                    <button className="text-large text-green-600"><IoIosCopy /></button>
                  </div>
                </div>
                <SearchField
                  extra="sm:min-w-[480px] xl:min-w-[650px]"
                  placeholder="Search by Address/ Txn Hash/ Block/ Token/Domain Name"
                  id="email"
                  type="text"
                />
              </div>
            </div>
            <div className="w-full flex text-center mt-3 md:mt-1">
              <div className="ml-auto md:mr-0 mr-auto flex gap-4">
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Buy <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Exchange <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Play <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="mt-6 md:mt-12 px-2.5 md:px-3 lg:px-5">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
            <div className="lg:col-span-5">
              <div className="box bg-white dark:bg-darkPrimary px-2.5 md:px-5 py-5">
                <img
                  src={NftIcon}
                  className="w-full rounded-[10px]"
                  alt=""
                />
              </div>
            </div>
            <div className="lg:col-span-7">
              <div className="box bg-white dark:bg-darkPrimary px-2.5 md:px-5 py-5">
                <p className="text-h3 mb-2.5">Owl Bridge #1014</p>
                <div className="flex gap-1 items-center mb-5">
                  <img
                    src={NftIcon}
                    className="w-6 h-6 rounded-[4px]"
                    alt=""
                  />
                  <span className="text-green-900">Owl Bridge</span>
                </div>
                <div className="border border-gray-100 dark:border-lightGrey rounded-[10px] grid grid-cols-1 lg:grid-cols-3 py-5 gap-4">
                  <Widget
                    title={"Collections"}
                    border="sm:border-r-[1px]"
                    subtitle={<span>255,471 <span className="text-gray-700 dark:text-gray-300">(40,547 NFTs)</span></span>}
                  />
                  <Widget
                    title={"24H Volume"}
                    border="sm:border-r-[1px]"
                    subtitle={<span>100,000.00 BBA <span className="text-green-600">(+62.54%)</span></span>}
                  />
                  <Widget
                    title={"24H NFT Listing"}
                    border="border-none"
                    subtitle={<span>1,457 <span className="text-green-600">(+62.54%)</span></span>}
                  />
                </div>
                <div className="mt-5">
                  <div className="py-4 text-h3 border-b-[1px] border-gray-100 dark:border-lightGrey">
                    Details
                  </div>
                  <div className="py-3 grid grid-cols-2 md:grid-cols-12 gap-3">
                    <div className="md:col-span-4 flex items-center">
                      <span className="text-medium text-gray-700 dark:text-gray-300">Owner:</span>
                    </div>
                    <div className="md:col-span-8">
                      <div className="flex gap-[2px] items-center">
                        <div className="truncateWrapper">
                          <p className="text-green-900 text-small truncate">
                          abc.bba
                          </p>
                        </div>
                        <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                      </div>
                    </div>
                  </div>
                  <div className="py-3 grid grid-cols-2 md:grid-cols-12 gap-3">
                    <div className="md:col-span-4 flex items-center">
                      <span className="text-medium text-gray-700 dark:text-gray-300">Contract Address:</span>
                    </div>
                    <div className="md:col-span-8">
                      <div className="flex gap-[2px] items-center">
                        <div className="truncateWrapper">
                          <p className="text-green-900 text-small truncate">
                          BrW3yUL4E3WDtK8Dyy5zvVs1KifxfVjKztvEDNxQhz7b
                          </p>
                        </div>
                        <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                      </div>
                    </div>
                  </div>
                  <div className="py-3 grid grid-cols-2 md:grid-cols-12 gap-3">
                    <div className="md:col-span-4 flex items-center">
                      <span className="text-medium text-gray-700 dark:text-gray-300">Creator:</span>
                    </div>
                    <div className="md:col-span-8">
                      <div className="flex gap-[2px] items-center">
                        <div className="truncateWrapper">
                          <p className="text-green-900 text-small truncate">
                          Owl,devs
                          </p>
                        </div>
                        <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                      </div>
                    </div>
                  </div>
                  <div className="py-3 grid grid-cols-2 md:grid-cols-12 gap-3">
                    <div className="md:col-span-4 flex items-center">
                      <span className="text-medium text-gray-700 dark:text-gray-300">Token ID:</span>
                    </div>
                    <div className="md:col-span-8">
                      <div className="flex gap-[2px] items-center">
                        <div className="truncateWrapper">
                          <p className="text-green-900 text-small truncate">
                          1025
                          </p>
                        </div>
                        <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                      </div>
                    </div>
                  </div>
                  <div className="py-3 grid grid-cols-2 md:grid-cols-12 gap-3">
                    <div className="md:col-span-4 flex items-center">
                      <span className="text-medium text-gray-700 dark:text-gray-300">Token Standards:</span>
                    </div>
                    <div className="md:col-span-8">
                      <div className="flex gap-[2px] items-center">
                        <div className="truncateWrapper">
                          <p className="truncate">
                            aaaaa
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="py-3 grid grid-cols-2 md:grid-cols-12 gap-3">
                    <div className="md:col-span-4 flex items-center">
                      <span className="text-medium text-gray-700 dark:text-gray-300">Marketplaces:</span>
                    </div>
                    <div className="md:col-span-8">
                      <div className="flex gap-[2px] items-center">
                        <div className="flex gap-2.5">
                          <img
                            src={Opensea}
                            className="w-[18px] h-[18px] rounded-full"
                            alt=""
                          />
                          <img
                            src={Opensea}
                            className="w-[18px] h-[18px] rounded-full"
                            alt=""
                          />
                          <img
                            src={Opensea}
                            className="w-[18px] h-[18px] rounded-full"
                            alt=""
                          />
                          <img
                            src={Opensea}
                            className="w-[18px] h-[18px] rounded-full"
                            alt=""
                          />
                          <img
                            src={Opensea}
                            className="w-[18px] h-[18px] rounded-full"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-5">
                  <div className="py-4 text-h3 border-b-[1px] border-gray-100 dark:border-lightGrey">
                  Properties (7)
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-4 2xl:grid-cols-6 gap-3 py-5">
                    <div className="bg-gray-200/25 py-1.5 px-2.5 text-center rounded-[8px] max-w-[100px] mx-auto">
                      <p className="text-xsmall !font-bold mb-1.5">Type</p>
                      <p className="text-gray-700 dark:text-gray-300 mb-1">Animal</p>
                      <p className="text-gray-700 dark:text-gray-300 mb-1">Rarity: 90.6%</p>
                    </div>
                    <div className="bg-gray-200/25 py-1.5 px-2.5 text-center rounded-[8px] max-w-[100px] mx-auto">
                      <p className="text-xsmall !font-bold mb-1.5">Type</p>
                      <p className="text-gray-700 dark:text-gray-300 mb-1">Animal</p>
                      <p className="text-gray-700 dark:text-gray-300 mb-1">Rarity: 90.6%</p>
                    </div>
                    <div className="bg-gray-200/25 py-1.5 px-2.5 text-center rounded-[8px] max-w-[100px] mx-auto">
                      <p className="text-xsmall !font-bold mb-1.5">Type</p>
                      <p className="text-gray-700 dark:text-gray-300 mb-1">Animal</p>
                      <p className="text-gray-700 dark:text-gray-300 mb-1">Rarity: 90.6%</p>
                    </div>
                    <div className="bg-gray-200/25 py-1.5 px-2.5 text-center rounded-[8px] max-w-[100px] mx-auto">
                      <p className="text-xsmall !font-bold mb-1.5">Type</p>
                      <p className="text-gray-700 dark:text-gray-300 mb-1">Animal</p>
                      <p className="text-gray-700 dark:text-gray-300 mb-1">Rarity: 90.6%</p>
                    </div>
                    <div className="bg-gray-200/25 py-1.5 px-2.5 text-center rounded-[8px] max-w-[100px] mx-auto">
                      <p className="text-xsmall !font-bold mb-1.5">Type</p>
                      <p className="text-gray-700 dark:text-gray-300 mb-1">Animal</p>
                      <p className="text-gray-700 dark:text-gray-300 mb-1">Rarity: 90.6%</p>
                    </div>
                    <div className="bg-gray-200/25 py-1.5 px-2.5 text-center rounded-[8px] max-w-[100px] mx-auto">
                      <p className="text-xsmall !font-bold mb-1.5">Type</p>
                      <p className="text-gray-700 dark:text-gray-300 mb-1">Animal</p>
                      <p className="text-gray-700 dark:text-gray-300 mb-1">Rarity: 90.6%</p>
                    </div>
                    <div className="bg-gray-200/25 py-1.5 px-2.5 text-center rounded-[8px] max-w-[100px] mx-auto">
                      <p className="text-xsmall !font-bold mb-1.5">Type</p>
                      <p className="text-gray-700 dark:text-gray-300 mb-1">Animal</p>
                      <p className="text-gray-700 dark:text-gray-300 mb-1">Rarity: 90.6%</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5 mb-12 px-2.5 md:px-3 lg:px-5">
          <div className="box bg-white dark:bg-darkPrimary overflow-hidden px-2.5 md:px-5 py-5">
            <div className="not-italic text-large px-2.5 md:px-5 py-4">
            Item Activity
            </div>
            <div className="table-wrapper">
              <table className="table w-full">
                <thead>
                  <tr className="">
                    <th className="w-[10px] !min-w-0 !pr-0"><a href="#" className="text-large" data-for="txs-tip" data-tip="See preview of Transactions Details"><PiQuestionLight /></a></th>
                    <th className="">Txn Hash</th>
                    <th className="">Action</th>
                    <th className="">Block</th>
                    <th className="">Age</th>
                    <th className="">From</th>
                    <th className="">To</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    Array(4).fill(0).map((data) => <tr>
                      <td className="!pr-0">
                        <a href="#" className="text-large"><PiEyeLight /></a>
                      </td>
                      <td>
                        <div className="flex gap-[1px] max-w-[160px]">
                          <div className="truncateWrapper">
                            <Link to="/txs/3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b" className="text-green-900 text-small truncate">
                              3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b
                            </Link>
                          </div>
                          <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                        </div>
                      </td>
                      <td>
                        <p className="text-small text-green-900">Bought</p>
                      </td>
                      <td>
                        <p className="text-small text-green-900">109,901,461</p>
                      </td>
                      <td>
                        <p className="text-small ">12 secs ago</p>
                      </td>
                      <td>
                        <div className="flex gap-[1px] max-w-[160px]">
                          <div className="truncateWrapper">
                            <p className="text-green-900 text-small truncate">3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b</p>
                          </div>
                          <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                        </div>
                      </td>
                      <td>
                        <div className="flex gap-[1px] max-w-[160px]">
                          <div className="truncateWrapper">
                            <p className="text-green-900 text-small truncate">3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b</p>
                          </div>
                          <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                        </div>
                      </td>
                    </tr>)
                  }
                  
                </tbody>
              </table>
            </div>
            <div className="py-5 justify-center md:justify-between flex mb-2">
              <div className="md:flex gap-2 hidden">
                <span className="text-small flex items-center">Show</span>
                <select className="text-small">
                  <option>10</option>
                  <option>20</option>
                  <option>50</option>
                  <option>100</option>
                </select>
                <span className="text-small flex items-center">Per Page</span>
              </div>
              <div className="flex gap-2">
                <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdSkipPrevious /></button>
                <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdNavigateBefore /></button>
                <span className="text-small flex items-center px-2">Page 1 of 25</span>
                <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdNavigateNext /></button>
                <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdSkipNext /></button>
              </div>
            </div>
          </div>
          <div className={`text-gray-700 dark:text-gray-300 text-xsmall flex items-center mt-5`}>
            <span className="text-large mr-1 mb-1"><HiOutlineLightBulb /></span>
            <span>
              The NFT page showcases information like attributes and transaction history for a particular token ID within an NFT contract. Discover more about this section in our
              <span className="text-green-900 ml-1">Knowledge Hub</span>.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NftDetail;
